export const SBX = "sbx";
export const DEV = "dev";
export const DEFAULT_APP_MODE = "";
export const FEASIBILITY_APP_ID = "ea9175e0-9c3f-4b52-bee8-fe13fb6b7838";
export const EXTRACT_APP_ID = "381fe244-ecd0-4bf7-bdd6-525716020685";
